import React, { useEffect, useRef, useState } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { arrowBack, arrowForward } from 'ionicons/icons';
import HelpCard from './HelpCard';
import { _helpCards } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';

interface VideoTutorialsSectionProps {
    
}

const VideoTutorialsSection: React.FC<VideoTutorialsSectionProps> = (props) => {
    const scrollContainer = useRef<HTMLDivElement>(null);
    const { lang } = useGlobalStore();
    const [isHelpCardOverflow, setIsHelpCardOverflow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (scrollContainer.current) {
                const containerWidth = scrollContainer.current.offsetWidth;
                const cardsWidth = _helpCards.length * 300; // Assuming each card has a fixed width of 300px
                setIsHelpCardOverflow(cardsWidth > containerWidth);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const scroll = (offset: number) => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollLeft += offset;
        }
    };


    return (
        <>
            <h1 className="help-page-title">Video Tutorial</h1>
            <div className="help-page-section">
                <div>
                    {isHelpCardOverflow && (
                        <>
                            <IonButton color="light" size="large" onClick={() => scroll(-300)}>
                                <IonIcon icon={arrowBack} size="large" />
                            </IonButton>
                            <IonButton color="light" size="large" onClick={() => scroll(300)}>
                                <IonIcon icon={arrowForward} size="large" />
                            </IonButton>
                        </>
                    )}
                </div>
                <div className="scroll-container" ref={scrollContainer}>
                    {_helpCards
                        .filter((el: any) => el[lang] !== undefined)
                        .map((el: any) => (
                            <div key={`help-card-${el[lang].title}`} className="help-card">
                                <HelpCard
                                    label={el[lang].title}
                                    description={el[lang].description}
                                    videoURL={el[lang].videoURL}
                                    
                                />
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
};

export default VideoTutorialsSection;
